// Site days as `YYYY-MM-DD` strings — the calendar every activity date, page
// window and lateness count is kept in. UTC arithmetic: once a site day is a
// string it has no zone, so none may creep back in through the host's.

const dayMs = (day: string): number => Date.parse(`${day}T00:00:00Z`);

/** `day` moved by `n` days (back when negative). */
export function addDays(day: string, n: number): string {
  const d = new Date(dayMs(day));
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** Whole days from `from` to `to`; negative when `to` is the earlier. */
export function daysBetween(from: string, to: string): number {
  return Math.round((dayMs(to) - dayMs(from)) / 86_400_000);
}

/** The Monday of the (Mon–Sun) week holding `day`. */
export function mondayOf(day: string): string {
  const weekday = new Date(dayMs(day)).getUTCDay(); // 0 Sun … 6 Sat
  return addDays(day, weekday === 0 ? -6 : 1 - weekday);
}
